import React from 'react';

import type { StatusCampaignPayloadBuilderState } from '~/utils/societePayloadBuilder/statusCampaign/types';
import { serializePreviewPayload } from '~/utils/societePayloadBuilder/statusCampaign/validatePayload';

import PayloadBuilderJsonPreview from '../JsonPreview';

interface StatusCampaignPayloadPreviewProps {
  state: StatusCampaignPayloadBuilderState;
  borderSoft: string;
  maxHeight: string;
}

export default function StatusCampaignPayloadPreview({ state, borderSoft, maxHeight }: StatusCampaignPayloadPreviewProps) {
  return (
    <PayloadBuilderJsonPreview
      state={state}
      serialize={serializePreviewPayload}
      borderSoft={borderSoft}
      maxHeight={maxHeight}
    />
  );
}
